(() => {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const videos = document.querySelectorAll('[data-water-video], [data-ambient-video]');
  videos.forEach((video) => {
    if (video.dataset.initialized) return;
    video.dataset.initialized = 'true';
    let visible = false;
    const update = () => {
      if (!visible || document.hidden || motion.matches) {
        video.pause();
        return;
      }
      const source = video.querySelector('source[data-src]');
      if (source) {
        source.src = source.dataset.src;
        delete source.dataset.src;
        video.load();
      }
      video.muted = true;
      video.play().catch(() => {});
    };
    const observer = new IntersectionObserver(([entry]) => {
      visible = entry.isIntersecting;
      update();
    }, { threshold: 0.1 });
    observer.observe(video);
    document.addEventListener('visibilitychange', update);
    motion.addEventListener('change', update);
  });
})();
